// src/components/Outro.js
import React from "react";
import "./Intro.css"; // Reusing the same CSS
import logo1 from "../assets/OmHaus_LOGO.png";
import logo2 from "../assets/e6a.png";
import logo3 from "../assets/olivares.png";
import logo4 from "../assets/logo.png";

const Outro = () => {
  return (
    <div>
      {/* Racó Patraix Section */}
      <section className="intro-section">
        <div className="intro-upper">
          <div className="text-left">
            <h1 className="intro-title-left">racó</h1>
          </div>
          <div className="text-right">
            <h1 className="intro-title-right">patraix</h1>
          </div>
        </div>
        <div className="footer-divider"></div>

        {/* Four Icons Section (like navbar) */}
        <div className="footer-section">
          <div className="outro-icons-container">
            <div className="outro-icon">
              <img src={logo1} alt="OmHaus" className="outro-icon-img" />
            </div>
            <div className="outro-icon">
              <img src={logo2} alt="E6A" className="outro-icon-img" />
            </div>
            <div className="outro-icon">
              <img src={logo3} alt="Olivares" className="outro-icon-img" />
            </div>
            <div className="outro-icon">
              <img src={logo4} alt="Logo" className="outro-icon-img" />
            </div>
          </div>
          <div className="spacer-300"></div>
          <div className="outro-info">
            <div className="outro-info-left">racopatraix.com</div>
            <div className="outro-info-center">📞 963 942 282</div>
            <div className="outro-info-right">C/ Agustina de Aragón, 11</div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Outro;
